import(/* webpackMode: "eager" */ "/vercel/path0/src/app/about/page.jsx");
